import { countChildren } from '@hc-frontend/business'

function getBadgeDental(title, members) {
  const childrenFound = countChildren(members) > 0

  let message = 'Higher Maximum Benefits'
  let hideTooltip = true
  if (/value/i.test(title)) {
    message = '100% Preventive'
  } else if (/essential/i.test(title)) {
    message = 'No Waiting Periods'
  } else if (/optimal vision/i.test(title)) {
    message = 'Eye Exam $15 Copay'
  } else if (/basic vision/i.test(title)) {
    message = 'Eye Exam $10 Copay'
  } else if (/advantage plus/i.test(title)) {
    if (/1000/i.test(title)) {
      message = '100% Preventive. PPO. $1,000 Benefit.'
    } else {
      message = '100% Preventive. PPO. $2,000 Benefit.'
    }
  } else if (/radiant/i.test(title)) {
    if (/plus/i.test(title)) {
      message = 'Orthodontia & Teeth Whitening'
    } else {
      message = 'Dental Credit for Prior Coverage'
    }
  } else if (childrenFound) {
    message = 'Orthodontics'
    hideTooltip = false
  }

  return {
    childrenFound,
    hideTooltip,
    message
  }
}

export default getBadgeDental
